import React from "react";
import ReactDOM from "react-dom/client";
import bootsrap from "bootstrap/dist/css/bootstrap.min.css";
import "./nav.css";
import Logo from "../images/logo-pen.png";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import AboutUsIcon from "../images/about-us.png";
import LeadershipIcon from "../images/leadership.png";
import FinanceIcon from "../images/financial-report.png";
import CsrIcon from "../images/csr.png";
import CareersIcon from "../images/careers.png";
import RsaIcon from "../images/retirement.png";
import AddIcon from "../images/Additional.png";
import CrossIcon from "../images/crossborder.png";
import Mfunds from "../images/managed.png";
import Ntsif from "../images/nsitf.png";
import Msg from "../images/chatcircle.png";
import Micropn from "../images/storefront.png";
import House from "../images/residential.png";
import Reasons from "../images/reasons.png";
import Unpaid from "../images/unpaid.png";
import Uncredited from "../images/uncredited.png";
import Payment from "../images/payment-types.png";
import Navmobile from "../images/logo-pen.png";
import Blog from "../images/blog.png";
import Download from "../images/downloads.png";
import Gallery from "../images/gallery.png";
import Faqs from "../images/FAQs.png";
import Calcu from "../images/calculator-nav.png";
import Whistle from "../images/whistleblowing.png";
import Client from "../images/client-login.png";
import Employer from "../images/employer-login.png";
import DRE from "../images/dre-portal.png";
import Enroll from "../images/enrollment-portal.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Search from "../images/search-icon-mb.png";
import { useState, useEffect } from "react";

import Invest from "./invest";
import Mobilenav from "./mobiledropdwn";

function Nav() {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const handleDropdownToggle = (itemName) => {
    if (activeDropdown === itemName) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(itemName);
    }
  };

  window.scrollTo(0, 0);
  {
    /* Returns nav items to default state when click happens outside of drop downs */
  }
  useEffect(() => {
    const dropdowns = document.querySelectorAll(".dropdown");

    const handleDropdownHide = () => {
      setActiveDropdown(null);
    };

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener("hidden.bs.dropdown", handleDropdownHide);
    });

    return () => {
      dropdowns.forEach((dropdown) => {
        dropdown.removeEventListener("hidden.bs.dropdown", handleDropdownHide);
      });
    };
  }, []);
  return (
    <>
      <div className="header d-flex align-items-center justify-content-center bg-danger ">
        <div className="header-text-wrapper">
          <p className=" text-center text-white header-p header-dsktop">
            Leadway PFA will never request for money or any form of
            gratification for any service rendered or received.
          </p>

          <p className="text-center text-white header-p header-mobile">
            Leadway PFA will never request for money or any form of
            gratification for any service rendered or received.
          </p>
          <p className="text-center text-white header-p header-mobile">
            Leadway PFA will never request for money or any form of
            gratification for any service rendered or received.
          </p>
   
        </div>
      </div>
      <nav
        class=" custom-navbar navbar navbar-expand-lg container-fluid d-flex justify-content-between align-items-center"
        id="navbar"
      >
  
           <Link to="/"> 
          <img src={Navmobile} alt="Leadway Logo" className="mobile-logo" />
             </Link>
     
        <a class="navbar-brand" href="#">
          <Link to="/"> 
          <img src={Logo} alt="Leadway Logo" className="logo" />
          </Link>
        </a>

        <div className="d-flex align-items-center">
        
          <button
            class="navbar-toggler custom-toggler collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        <div
          class="collapse navbar-collapse flex-grow-1 justify-content-center"
          id="navbarSupportedContent"
        >
          <ul
            id="nav-opt"
            class="navbar-nav nav-list mb-2 mb-lg-0 d-flex justify-content-center w-100 gap-3"
          >
            <li id="nav-item" class="nav-item dropdown">
              <Link
                id="nav--link"
                onClick={() => handleDropdownToggle("Company")}
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span
                  className={`${
                    activeDropdown === "Company" ? "orange-nav-item" : ""
                  }`}
                >
                  {" "}
                  Company{" "}
                </span>
                <FontAwesomeIcon
                  className={` ${
                    activeDropdown === "Company"
                      ? "arrow-icon rotated"
                      : "arrow-icon rotate-back"
                  }      chv-dwn`}
                  icon={faChevronDown}
                />
              </Link>
              <ul className="company-nav-dropdown dropdown-menu">
                <div id="drpdwn-menu">
                  <div class="inner-nav-elements">
                    <li>
                      <Link
                        to="/about-us"
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        onClick={() => setActiveDropdown(null)}
                        href="#"
                      >
                        <img
                          src={AboutUsIcon}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">About Us</p>
                          <p className="nav-item-p-2">
                            Learn what drives us and how we operate.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/leadership"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={LeadershipIcon}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Leadership</p>
                          <p className="nav-item-p-2">
                            Meet the people guiding our mission.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/financial-reports"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={FinanceIcon}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Financial Report</p>
                          <p className="nav-item-p-2">
                            See our yearly performance and growth.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                  </div>

                  <div class="inner-nav-elements">
                    <li>
                      <Link
                        to="/corporate-responsibility"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={CsrIcon}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">CSR</p>
                          <p className="nav-item-p-2">
                            See how we’re giving back to society.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/careers"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={CareersIcon}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Careers</p>
                          <p className="nav-item-p-2">
                            Join a passionate team shaping the future.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                  </div>
                </div>
              </ul>
            </li>
            <li class="desktop-login nav-item dropdown">
              <Link
                id="nav--link"
                onClick={() => handleDropdownToggle("Services")}
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span
                  className={`${
                    activeDropdown === "Services" ? "orange-nav-item" : ""
                  }`}
                >
                  {" "}
                  Services{" "}
                </span>

                <FontAwesomeIcon
                  className={` ${
                    activeDropdown === "Services"
                      ? "arrow-icon rotated"
                      : "arrow-icon rotate-back"
                  }      chv-dwn`}
                  icon={faChevronDown}
                />
              </Link>
              <ul class="services-nav-dropdown dropdown-menu">
                <div id="drpdwn-menu">
                  <div class="inner-nav-elements">
                    <li>
                      <Link
                        to="/products/rsa"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={RsaIcon}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">
                            Retirement Savings Account
                          </p>
                          <p className="nav-item-p-2">
                            Save for the future with a secure RSA..{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products/avc"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={AddIcon}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">
                            Additional Voluntary Contribution
                          </p>
                          <p className="nav-item-p-2">
                            Top up your pension with flexible extras.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="products/cross-border-services"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={CrossIcon}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Cross Border Services</p>
                          <p className="nav-item-p-2">
                            Save while working abroad or returning.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                  </div>
                  <div class="inner-nav-elements">
                    <li>
                      <Link
                        to="/products/managed-funds"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Mfunds}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Managed Funds</p>
                          <p className="nav-item-p-2">
                            Custom fund management for institutions.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/services/NSITF"
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Ntsif}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">NSITF</p>
                          <p className="nav-item-p-2">
                            Transfer your old pension into your RSA.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products/personal-messaging-service"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Msg}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">
                            Personal Messaging Service
                          </p>
                          <p className="nav-item-p-2">
                            Access pension info instantly via SMS.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                  </div>

                  <div class="inner-nav-elements">
                    <li>
                      <Link
                        to="/products/micro-pensions"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Micropn}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Micro Pension</p>
                          <p className="nav-item-p-2">
                            Save for retirement as a freelancer.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products/residential-mortgage-access"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={House}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">25% Residential Mortgage</p>
                          <p className="nav-item-p-2">
                            Use your pension to own a home.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                  </div>
                </div>
              </ul>
            </li>
            {/*Services Mobile Nav */}
            <li class="mobile-login nav-item dropdown">
              <Link
                id="nav--link"
                onClick={() => handleDropdownToggle("Services")}
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span
                  className={`${
                    activeDropdown === "Services" ? "orange-nav-item" : ""
                  }`}
                >
                  Services
                </span>
                <FontAwesomeIcon
                  className={`${
                    activeDropdown === "Services"
                      ? "arrow-icon rotated"
                      : "arrow-icon rotate-back"
                  } chv-dwn`}
                  icon={faChevronDown}
                />
              </Link>

              <ul class="services-nav-dropdown dropdown-menu">
                <div id="drpdwn-menu">
                  {/* First column */}
                  <div class="inner-nav-elements">
                    <li>
                      <Link
                        to="/products/rsa"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={RsaIcon}
                          alt="RSA"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">
                            Retirement Savings Account
                          </p>
                          <p className="nav-item-p-2">
                            Save for the future with a secure RSA.
                          </p>
                        </div>
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/products/avc"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={AddIcon}
                          alt="AVC"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">
                            Additional Voluntary Contribution
                          </p>
                          <p className="nav-item-p-2">
                            Top up your pension with flexible extras.
                          </p>
                        </div>
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="products/cross-border-services"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={CrossIcon}
                          alt="Cross Border"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Cross Border Services</p>
                          <p className="nav-item-p-2">
                            Save while working abroad or returning.
                          </p>
                        </div>
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/products/managed-funds"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Mfunds}
                          alt="Managed Funds"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Managed Funds</p>
                          <p className="nav-item-p-2">
                            Custom fund management for institutions.
                          </p>
                        </div>
                      </Link>
                    </li>
                  </div>

                  {/* Second column */}
                  <div class="inner-nav-elements">
                    <li>
                      <Link
                        to="/services/NSITF"
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        
                      >
                        <img
                          src={Ntsif}
                          alt="NSITF"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">NSITF</p>
                          <p className="nav-item-p-2">
                            Transfer your old pension into your <br /> RSA.
                          </p>
                        </div>
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/products/personal-messaging-service"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Msg}
                          alt="Personal Messaging"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">
                            Personal Messaging Service
                          </p>
                          <p className="nav-item-p-2">
                            Access pension info instantly via SMS.
                          </p>
                        </div>
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/products/micro-pensions"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Micropn}
                          alt="Micro Pension"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Micro Pension</p>
                          <p className="nav-item-p-2">
                            Save for retirement as a freelancer.
                          </p>
                        </div>
                      </Link>
                    </li>

                    <li id="resident">
                      <Link
                        to="/products/residential-mortgage-access"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={House}
                          alt="Residential Mortgage"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">25% Residential Mortgage</p>
                          <p className="nav-item-p-2">
                            Use your pension to own a home.
                          </p>
                        </div>
                      </Link>
                    </li>
                  </div>
                </div>
              </ul>
            </li>

            <li class="nav-item dropdown">
              <Link
                id="nav--link"
                onClick={() => handleDropdownToggle("Benefits")}
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span
                  className={`${
                    activeDropdown === "Benefits" ? "orange-nav-item" : ""
                  }`}
                >
                  {" "}
                  Benefits{" "}
                </span>
                <FontAwesomeIcon
                  className={` ${
                    activeDropdown === "Benefits"
                      ? "arrow-icon rotated"
                      : "arrow-icon rotate-back"
                  }      chv-dwn`}
                  icon={faChevronDown}
                />
              </Link>
              <ul
                id="benefits-mobile-nav"
                class="benefits-nav-dropdown dropdown-menu"
              >
                <div id="drpdwn-menu">
                  <div class="inner-nav-elements">
                    <li>
                      <Link
                        to="/services/withdrawal"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Reasons}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Reasons for Withdrawal</p>
                          <p className="nav-item-p-2">
                            See when and how you can access your RSA.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/services/group-life"
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Unpaid}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">
                            Unpaid Grouplife & Accrued Rights
                          </p>
                          <p className="nav-item-p-2">
                            Meet the people guiding our mission.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                  </div>

                  <div class="inner-nav-elements">
                    <li>
                         <Link
                        to="/services/unpaid-credit"
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Uncredited}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Uncredited Funds</p>
                          <p className="nav-item-p-2">
                            Track unprocessed pension contributions.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/services/payment-types"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                      
                      >
                        <img
                          src={CareersIcon}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Payment Types</p>
                          <p className="nav-item-p-2">
                            Know your retirement benefit options.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                  </div>
                </div>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <Link
                id="nav--link"
                class="nav-link dropdown-toggle"
                to="/invest"
                role="button"
              
              >
                Investment{" "}
              </Link>
            </li>
            <li class="nav-item dropdown">
              <Link
                id="nav--link"
                onClick={() => handleDropdownToggle("Resources")}
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span
                  className={`${
                    activeDropdown === "Resources" ? "orange-nav-item" : ""
                  }`}
                >
                  {" "}
                  Resources{" "}
                </span>
                <FontAwesomeIcon
                  className={` ${
                    activeDropdown === "Resources"
                      ? "arrow-icon rotated"
                      : "arrow-icon rotate-back"
                  }      chv-dwn`}
                  icon={faChevronDown}
                />
              </Link>
              <ul
                id="Resources-mobile-nav"
                class="resources-nav-dropdown dropdown-menu"
              >
                <div id="drpdwn-menu">
                  <div
                    id="inner-nav-elements-resources"
                    class="inner-nav-elements"
                  >
                    <li>
                      <Link
                        to="/blog"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Blog}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Blog</p>
                          <p className="nav-item-p-2">
                            Explore pension tips, updates and insights.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/download"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Download}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div>
                          <p className="nav-item-p">Downloads</p>
                          <p className="nav-item-p-2">
                            Access forms, guides, <br /> and reports.
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li className="gallery-mob">
                      <Link
                        to="/gallery"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Gallery}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Gallery</p>
                          <p className="nav-item-p-2">
                            Moments and milestones in pictures.
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/frequently-asked-questions"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Faqs}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">FAQs</p>
                          <p className="nav-item-p-2">
                            Get answers to common pension questions.
                          </p>
                        </div>
                      </Link>
                    </li>
                  </div>

                  <div
                    id="inner-nav-elements-resources"
                    class="inner-nav-elements"
                  >
                    <li>
                      <Link
                        to="#"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                       
                      >
                        <img
                          src={Calcu}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Calculator</p>
                          <p className="nav-item-p-2">
                            Estimate your retirement savings now.
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                         <Link
                        to="/fund-price"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={FinanceIcon}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Real-Time Fund Charts</p>
                          <p className="nav-item-p-2">
                            View real-time fund prices and charts.{" "}
                          </p>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/whistle-blower"
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="#"
                      >
                        <img
                          src={Whistle}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div className="text-wrap">
                          <p className="nav-item-p">Whistleblowings</p>
                          <p className="nav-item-p-2">
                            Report any misconduct safely and easily.
                          </p>
                        </div>
                      </Link>
                    </li>
                  </div>
                </div>
              </ul>
            </li>
            {/* MOBILE LOGIN*/}
            <form id="login-form-mob" class="d-flex mobile-login" role="search">
              <ul class="navbar-nav  mb-2 mb-lg-0 align-items-center">
                <li id="opn-acc" class=" open-acc-mb nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle"
                    href="https://reg.leadwaypfa.com/"
                    role="button"
                    target="_blank"
                  >
                    Open An Account{" "}
                    <FontAwesomeIcon
                      className="chv-dwn-arr"
                      icon={faArrowRight}
                    />
                  </a>
                </li>
                <li class="nav-item dropdown">
                  <Link
                    onClick={() => handleDropdownToggle("Login")}
                    class="nav-link dropdown-toggle text-center"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span
                      className={`${
                        activeDropdown === "Login" ? "orange-nav-item" : ""
                      }`}
                    >
                      {" "}
                      Login{" "}
                    </span>
                    <FontAwesomeIcon
                      className={` ${
                        activeDropdown === "Login"
                          ? "arrow-icon rotated"
                          : "arrow-icon rotate-back"
                      }      chv-dwn`}
                      icon={faChevronDown}
                    />
                  </Link>
                  <ul id="form-mob" class=" dropdown-menu">
                    <div id="drpdwn-menu-login">
                      <div id="inner-mb" class="inner-nav-elements">
                        <li>
                          <a
                            onClick={() => setActiveDropdown(null)}
                            id="nav-drpdwn-itm"
                            class="dropdown-item no-decoration"
                            href="https://p-online.leadway-pensure.com"
                          >
                            <img
                              src={Client}
                              alt="About Us"
                              className="nav-icon mt-1"
                            />
                            <div>
                              <p className="nav-item-p">Client Login</p>
                              <p className="nav-item-p-2">
                                Access your RSA and <br /> pension details.{" "}
                              </p>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => setActiveDropdown(null)}
                            id="nav-drpdwn-itm"
                            class="dropdown-item no-decoration"
                            href="https://employerportal.leadwaypfa.com"
                          >
                            <img
                              src={Employer}
                              alt="About Us"
                              className="nav-icon mt-1"
                            />
                            <div>
                              <p className="nav-item-p">Employer Login</p>
                              <p className="nav-item-p-2">
                                Manage staff <br /> contributions with <br />{" "}
                                ease.
                              </p>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => setActiveDropdown(null)}
                            id="nav-drpdwn-itm"
                            class="dropdown-item no-decoration"
                            href="https://p-online2.leadway-pensure.com/investor-portal/login"
                          >
                            <img
                              src={FinanceIcon}
                              alt="About Us"
                              className="nav-icon mt-1"
                            />
                            <div>
                              <p className="nav-item-p">Investor Portal</p>
                              <p className="nav-item-p-2">
                                View fund <br /> performance and <br /> reports.
                              </p>
                            </div>
                          </a>
                        </li>
                      </div>

                      <div id="inner-mb" class="inner-nav-elements">
                        <li>
                          <a
                            onClick={() => setActiveDropdown(null)}
                            id="nav-drpdwn-itm"
                            class="dropdown-item"
                            href="https://penlite.leadwaypfa.com/Feedback/DREREquirement"
                          >
                            <img
                              src={DRE}
                              alt="About Us"
                              className="nav-icon mt-1"
                            />
                            <div>
                              <p className="nav-item-p">DRE Portal</p>
                              <p className="nav-item-p-2">
                                For DRE-specific <br /> access and data <br />{" "}
                                tools.
                              </p>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => setActiveDropdown(null)}
                            id="nav-drpdwn-itm"
                            class="dropdown-item"
                            href="https://p-online.leadway-pensure.com/enrolmentportal"
                            data-target="_blank"
                          >
                            <img
                              src={Enroll}
                              alt="About Us"
                              className="nav-icon mt-1"
                            />
                            <div>
                              <p className="nav-item-p">Enrollment Portal</p>
                              <p className="nav-item-p-2">
                                Register new <br /> employees or clients <br />{" "}
                                easily.
                              </p>
                            </div>
                          </a>
                        </li>
                      </div>
                    </div>
                  </ul>
                </li>
              </ul>
            </form>
          </ul>
        </div>
        <form id="login-form" class="d-flex desktop-login" role="search">
          <ul class=" navbar-nav  mb-2 mb-lg-0 align-items-center">
            <li class="nav-item dropdown">
              <Link
                onClick={() => handleDropdownToggle("Login")}
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span
                  className={`${
                    activeDropdown === "Login" ? "orange-nav-item" : ""
                  }`}
                >
                  {" "}
                  Login{" "}
                </span>
                <FontAwesomeIcon
                  className={` ${
                    activeDropdown === "Login"
                      ? "arrow-icon rotated"
                      : "arrow-icon rotate-back"
                  }      chv-dwn`}
                  icon={faChevronDown}
                />
              </Link>
              <ul class="login-nav-dropdown dropdown-menu">
                <div id="drpdwn-menu">
                  <div class="inner-nav-elements">
                    <li>
                      <a
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                          href="https://p-online.leadway-pensure.com"
                          data-target="_blank"
                      >
                        <img
                          src={Client}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div>
                          <p className="nav-item-p">Client Login</p>
                          <p className="nav-item-p-2">
                            Access your RSA and pension <br /> details.{" "}
                          </p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                           href="https://employerportal.leadway-pensure.com"
                            data-target="_blank"
                      >
                        <img
                          src={Employer}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div>
                          <p className="nav-item-p">Employer Login</p>
                          <p className="nav-item-p-2">
                            Manage staff contributions with <br /> ease.
                          </p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                           href="https://p-online2.leadway-pensure.com/investor-portal/login"
                            data-target="_blank"
                      >
                        <img
                          src={FinanceIcon}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div>
                          <p className="nav-item-p">Investor Portal</p>
                          <p className="nav-item-p-2">
                            View fund performance and <br /> reports.
                          </p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                        href="https://p-online.leadway-pensure.com/lppfa-datarecapture"
                        data-target="_blank"
                      >
                        <img
                          src={DRE}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div>
                          <p className="nav-item-p">DRE Portal</p>
                          <p className="nav-item-p-2">
                            For DRE-specific access and data <br /> tools.
                          </p>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => setActiveDropdown(null)}
                        id="nav-drpdwn-itm"
                        class="dropdown-item"
                           href="https://p-online.leadway-pensure.com/enrolmentportal"
                            data-target="_blank"
                      >
                        <img
                          src={Enroll}
                          alt="About Us"
                          className="nav-icon mt-1"
                        />
                        <div>
                          <p className="nav-item-p">Enrollment Portal</p>
                          <p className="nav-item-p-2">
                            Register new employees or clients <br /> easily.
                          </p>
                        </div>
                      </a>
                    </li>
                  </div>
                </div>
              </ul>
            </li>
            <li id="opn-acc" class="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="/products/rsa"
                role="button"
              
              >
                Open An Account{" "}
                <FontAwesomeIcon className="chv-dwn-arr" icon={faArrowRight} />
              </Link>
            </li>
          </ul>
        </form>
      </nav>
    </>
  );
}

export default Nav;
